document.addEventListener("DOMContentLoaded", () => {
  const paper = document.getElementById("filterPanel");
  const header = paper.querySelector(".paper-header");

  let startY = 0;
  let currentHeight = paper.clientHeight; // Kezdeti magasság vh-ban
  const minHeight = 5; // Minimális magasság vh-ban
  const maxHeight = 100; // Maximális magasság vh-ban
  let isDragging = false;

  header.addEventListener("touchstart", (e) => {
    e.preventDefault(); // Az alapértelmezett viselkedés letiltása
    startY = e.touches[0].clientY;
  });

  header.addEventListener("touchmove", (e) => {
    e.preventDefault(); // Az alapértelmezett viselkedés letiltása
    const touchY = e.touches[0].clientY;
    const deltaY = startY - touchY;

    // Új magasság kiszámítása
    let newHeight = currentHeight + (deltaY / window.innerHeight) * 100;
    newHeight = Math.max(minHeight, Math.min(maxHeight, newHeight));
    paper.style.height = `${newHeight}vh`;
  });

  header.addEventListener("touchend", () => {
    currentHeight = parseFloat(paper.style.height);
  });
  header.addEventListener("mousedown", (e) => {
    e.preventDefault(); // Az alapértelmezett viselkedés letiltása
    isDragging = true;
    startY = e.clientY;
  });
  document.body.addEventListener("mousemove", (e) => {
    e.preventDefault(); // Az alapértelmezett viselkedés letiltása
    if(!isDragging) return;
    const touchY = e.clientY;
    const deltaY = startY - touchY;
    // Új magasság kiszámítása
    let newHeight = currentHeight + (deltaY / window.innerHeight) * 100;
    newHeight = Math.max(minHeight, Math.min(maxHeight, newHeight));
    paper.style.height = `${newHeight}vh`;
  });
  document.body.addEventListener("mouseup", () => {
    if(!isDragging) return;
    isDragging = false;
    currentHeight = parseFloat(paper.style.height);
  });
  document.addEventListener("mouseleave", (e) => {
    if(!isDragging) return;
    isDragging = false;
    currentHeight = parseFloat(paper.style.height);
  });
});
